import { combineEpics } from 'redux-observable';
import * as inventoryEpics from '../features/inventory/epics';

const rootEpic = combineEpics(...Object.values(inventoryEpics));

export default rootEpic;
